import { memo, useCallback, useState } from 'react'
import { Observer } from 'mobx-react-lite'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

import Modals from 'singletons/Modals'

import DailyVideoChat from './DailyVideoChat'
import CallDeviceSettingsModal from 'components/Dashboard/Main/Visit/VisitPanel/common/CallDeviceSettings'

type VideoChatViewProps = {
  // TODO - add type for store
  store: any
  className?: string
  compact?: boolean
}

const VideoChatView = ({ store, className, compact }: VideoChatViewProps) => {
  const [deviceSettingsOpened, setDeviceSettingsOpened] = useState(false)

  const onChatClick = () => store.showChat()

  const onHangupClick = () =>
    Modals.open('confirmEndCall', {
      onConfirm: () => store.stopVideo(),
      visit: store.visit,
    })

  const toggleSettingsOpened = useCallback(
    (_open: boolean) => () => {
      setDeviceSettingsOpened(_open)
    },
    [],
  )

  return (
    <>
      <Observer>
        {() => (
          <DailyVideoChat
            className={classNames('relative h-auto max-h-[100%] items-center', className)}
            compact={compact}
            actions={{
              chat: onChatClick,
              hangup: onHangupClick,
              settings: toggleSettingsOpened(true),
              chatBadgeValue: store.visit?.chat.length,
            }}
          />
        )}
      </Observer>
      {deviceSettingsOpened && (
        <CallDeviceSettingsModal
          deviceSettings={store.video.deviceSettings}
          opened
          onClose={toggleSettingsOpened(false)}
        />
      )}
    </>
  )
}

export default memo(VideoChatView)
